import axios from "axios";
import BaseService from "./baseService";

class ServiceScheduledEmailsController extends BaseService {
  async sendTestSupplierInsuranceReminder(email: string) {
    const response = await axios.post(
      "/api/scheduledEmails/test/supplierInsuranceReminder",
      { email },
    );
    return response.data as { success: boolean; message: string };
  }
}

export const ServiceScheduledEmails = new ServiceScheduledEmailsController();
